import { type IResponseOutboundSource } from 'entities/OutboundSource/api/types'

export class OutboundSource {
  id: string
  key: string
  label: string
  origin: IResponseOutboundSource

  constructor(item: IResponseOutboundSource) {
    this.id = item.key
    this.key = item.key
    this.label = item.label
    this.origin = item
  }
}
